import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./SkeletonLoader.scss";

const variants = {
  CIRCULAR: "circular",
  ROUNDED: "rounded",
  RECTANGULAR: "rectangular",
};

const SkeletonLoader = props => {
  const { variant, width, height, maxWidth, maxHeight, customClasses } = props;

  const containerClasses = classNames(
    {
      [classes.container]: true,
      [classes.circular]: variant === variants.CIRCULAR,
      [classes.rounded]: variant === variants.ROUNDED,
      [classes.rectangular]: variant === variants.RECTANGULAR,
    },
    customClasses
  );

  const style = { width, height, maxWidth, maxHeight };
  return <div style={style} className={containerClasses} />;
};

SkeletonLoader.propTypes = {
  variant: PropTypes.oneOf(_.values(variants)),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customClasses: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

SkeletonLoader.defaultProps = {
  variant: variants.ROUNDED,
};

export default SkeletonLoader;
